import { CategoryEnum, Pagination, ProductType, RecommendationType } from '@/@types';
import { gql, paginationToArray } from './_utils';
import { NamespaceArgsType } from './@types';

export const Recommendation = ({ graphqlRequest }: NamespaceArgsType) => {
  return {
    get: async (id: string) => {
      return graphqlRequest<{ Recommendation: { get?: RecommendationType } }>({
        query: gql`
          query getReco($id: ID!) {
            Recommendation {
              get(id: $id) {
                id
                message
                user {
                  id
                  nickname
                }
                media {
                  type
                  source
                }
              }
            }
          }
        `,
        variables: { id },
      }).then((x) => {
        return x.data.Recommendation.get;
      });
    },
    find: async (cursor?: string, userId?: string) => {
      return graphqlRequest<{
        Recommendation: {
          find: {
            total: number;
            edges: [{ node: RecommendationType; cursor: string }];
            pageInfo: { endCursor: string; hasNextPage: boolean };
          };
        };
      }>({
        query: gql`
          query RecommendationFind($after: ID, $filters: recommendationsfilter) {
            Recommendation {
              find(pagination: { after: $after }, filters: $filters) {
                total
                edges {
                  node {
                    id
                    message
                    product {
                      id
                      name
                      image
                      category {
                        id
                        name
                      }
                      media {
                        type
                        source
                      }
                    }
                    user {
                      id
                      name
                      lastname
                      nickname
                      avatar
                    }
                  }
                  cursor
                }
                pageInfo {
                  endCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: { after: cursor, filters: { user: { ids: [userId].filter(Boolean) } } },
      });
    },
    explore: async (variables: { category: CategoryEnum; first: number }): Promise<ProductType[]> => {
      return graphqlRequest<{ Category: { get: { products: Pagination<ProductType> } } }>({
        query: gql`
          query PopularProducts($category: ID!, $limit: Int) {
            Category {
              get(id: $category) {
                products(pagination: { first: $limit, sortBy: POPULARITY }) {
                  edges {
                    node {
                      id
                      name
                      category {
                        name
                        id
                      }
                      media {
                        type
                        source
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        variables,
      }).then((val) => {
        return paginationToArray(val.data.Category.get.products);
      });
    },
  };
};
